/**
 * The request body of "Print Bill" on the payment screen (POST /v3/cart/printdocket): the bill printed for the customer to review BEFORE they pay.
 * It carries what the payment will carry, so the printed bill shows the same total: the payment mode, the tip and the manual discount staff applied
 * on this screen (held in the page until payment, so the server cannot know it otherwise).
 */
export function buildPrintBillPayload({ orderId, tableId, paymentMethod, gratuitySurchargeId, manualDiscountType, manualDiscountValue }) {
  const payload = { order_id: orderId };
  if (tableId) payload.table_id = tableId;
  if (paymentMethod) payload.payment_mode = paymentMethod;
  if (gratuitySurchargeId) payload.gratuity_surcharge_id = gratuitySurchargeId;
  if (manualDiscountType && manualDiscountValue) {
    payload.manual_discount_type = manualDiscountType;
    payload.manual_discount_value = manualDiscountValue;
  }
  return payload;
}
